import { vuex_subscribe_module, vuex_store_config } from '@/vuex'
import { load_state_from_local_storage } from '@/resources'

const vuex_config_object = {
  location: {
    label: '',
    latitude: '',
    longitude: '',
    match_level: '',
    name: '',
  },
  checkin: '',
  checkout: '',
  hotels: [],
  current_search: '',
  selected_property: {},
  selected_invadobay: {},
  selected_solution: {
    dates: {},
    occupancy: [],
    property: {},
  },
  last_search: '',
  trigger_search: false,
  // filtri ricerca
  filter_availability: false,
  filter_refundable: false,
  filter_stars: [],
  filter_amenities: [],
  filter_categories_structure: {},
  filter_rate_amenities: [],
  filter_hotel_categories: [],
  filter_salabam_scores: [],
  filter_price_range: {},
  filter_price_settings: {},
  filter_review_score: 0,
  filter_preferred: 0,
  // ordinamento risultati
  order: {
    by: '',
    descending: false,
  },
}

export const serialized_vuex_config_object = JSON.stringify(vuex_config_object)

const state_config = vuex_store_config(vuex_config_object)

let name = 'liveeps',
  state = state_config.state,
  module = {
    namespaced: true,
    state: load_state_from_local_storage(name, state_config.state),
    mutations: {
      ...state_config.mutations,

      // aggiorna selected_hotel
      update_selected_property(state, payload) {
        state.selected_property = payload
      },

      // aggiorna selected_solution
      update_selected_solution(state, payload) {
        state.selected_solution = payload
      },

      // aggiorna property in selected_solution
      update_property(state, payload) {
        state.selected_solution.property = payload
      }
    },
    getters: state_config.getters,
    actions: state_config.actions,
    get_local_storage_submodule() {
      // dichiaro le chiavi che verranno scritte nel local storage
      return {
        location: state_config.state.location,
        checkin: state_config.state.checkin,
        checkout: state_config.state.checkout,
        last_search: state_config.state.last_search,
        current_search: state_config.state.current_search,
        selected_property: {},
        selected_invadobay: {},
        selected_solution: {},
        //filter_availability: state_config.state.filter_availability,
        //filter_refundable: state_config.state.filter_refundable,
        //filter_stars: state_config.state.filter_stars,
        //filter_amenities: state_config.state.filter_amenities,
        //filter_rate_amenities: state_config.state.filter_rate_amenities,
        //filter_hotel_categories: state_config.state.filter_hotel_categories,
        //filter_review_score: state_config.state.filter_review_score,
        //filter_preferred: state_config.state.filter_preferred,
        //filter_price_range: state_config.state.filter_price_range,
        sort_by: state_config.state.sort_by,
      }
    },
  }

export function register_state_module(prototype) {
  if (prototype.$submodules == undefined) prototype.$submodules = {}
  prototype.$submodules[name] = {
    get_local_storage_submodule: module.get_local_storage_submodule()
  }
  vuex_subscribe_module(name, state, module)
}